import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-consult',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './consult.component.html',
  styleUrl: './consult.component.css',
})
export class ConsultComponent {}
